import * as React from 'react';
import * as DialogPrimitive from '@radix-ui/react-dialog';
import { X } from 'lucide-react';
import { cn } from '@/lib/utils';

export const Dialogo = DialogPrimitive.Root;
export const DialogoGatilho = DialogPrimitive.Trigger;
export const DialogoFechar = DialogPrimitive.Close;

export function DialogoConteudo({
  className,
  children,
  ...props
}: React.ComponentProps<typeof DialogPrimitive.Content>) {
  return (
    <DialogPrimitive.Portal>
      <DialogPrimitive.Overlay className="fixed inset-0 z-50 bg-black/50 backdrop-blur-[1px]" />
      <DialogPrimitive.Content
        className={cn(
          'bg-cartao text-cartao-texto fixed top-1/2 left-1/2 z-50 w-[calc(100vw-2rem)] max-w-lg',
          '-translate-x-1/2 -translate-y-1/2 rounded-xl border shadow-lg',
          // Formulários longos não podem estourar a altura da janela.
          'max-h-[calc(100dvh-3rem)] overflow-y-auto',
          className,
        )}
        {...props}
      >
        {children}
        <DialogPrimitive.Close
          className="text-silenciado-texto hover:bg-silenciado absolute top-4 right-4 rounded-md p-1"
          aria-label="Fechar"
        >
          <X className="size-4" aria-hidden="true" />
        </DialogPrimitive.Close>
      </DialogPrimitive.Content>
    </DialogPrimitive.Portal>
  );
}

export function DialogoCabecalho({ className, ...props }: React.ComponentProps<'div'>) {
  return (
    <div
      className={cn(
        // O `pr-14` reserva a faixa do botão de fechar, que é posicionado
        // absoluto sobre o conteúdo. Sem ele, título longo passa por baixo do X
        // — e o que fica ilegível é justamente a pergunta que o modal faz.
        'flex flex-col gap-1 p-5 pr-14 pb-0',
        className,
      )}
      {...props}
    />
  );
}

export function DialogoTitulo({
  className,
  ...props
}: React.ComponentProps<typeof DialogPrimitive.Title>) {
  return (
    <DialogPrimitive.Title
      // `leading-snug`, e não `leading-none`: título que ocupa duas linhas
      // tinha as linhas se tocando.
      className={cn('text-lg leading-snug font-semibold', className)}
      {...props}
    />
  );
}

export function DialogoDescricao({
  className,
  ...props
}: React.ComponentProps<typeof DialogPrimitive.Description>) {
  return (
    <DialogPrimitive.Description
      className={cn('text-silenciado-texto text-sm', className)}
      {...props}
    />
  );
}

export function DialogoCorpo({ className, ...props }: React.ComponentProps<'div'>) {
  return <div className={cn('flex flex-col gap-4 p-5', className)} {...props} />;
}

export function DialogoRodape({ className, ...props }: React.ComponentProps<'div'>) {
  return (
    <div
      className={cn('flex flex-col-reverse gap-2 p-5 pt-0 sm:flex-row sm:justify-end', className)}
      {...props}
    />
  );
}
